import * as React from 'react';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Translate from '../../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import Button from "@material-ui/core/Button";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import CategoryService from '../../../services/categoriesService';
import Spinner from '../../../common/components/spinner/spinner';
import Snackbar from "../../../common/components/snackbar/snackbar";
import { CategoryModel } from '../../../models/category/categoryModel';
import { DropdownModel } from '../../../models/dropdownModel';
import { CategoryType } from '../../../common/enums';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

interface IProps {
  closeAddEditCategoryModal: any,
  cancelClick: any,
  saveClick: any,
  isVisible: boolean,
  currentCategory: CategoryModel,
}

interface IState {
  category: CategoryModel,
  validationMessage: string,
  isLoading: boolean,
  categoryTypes: Array<DropdownModel>,
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: '0px'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '90% !important'
      },
      paperFullWidth: {
        width: '30%'
      }
    },
  },
  palette: {
    primary: blue
  }
})

class CategoryAddEditDialog extends React.Component<IProps, IState> {
  snackbar: any;
  categoryService = new CategoryService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      category: props.currentCategory,
      validationMessage: '',
      isLoading: false,
      categoryTypes: new Array<DropdownModel>(0),
    };
  }

  componentDidMount() {
    var currentCategory = this.props.currentCategory;
    if (!currentCategory.id) {
      currentCategory.isActive = true;
      this.setState({ category: currentCategory });
    }

    let allowedCategoryTypes: Array<number> = [];

    if (!this.props.currentCategory.parentId) {
      allowedCategoryTypes = [0, 1, 2];
    }
    else {
      allowedCategoryTypes = [0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    }

    const categoryTypes: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];

    this.setState({
      categoryTypes: categoryTypes.concat(HelperFunctions.enumToDropdownArray(CategoryType, true).sort((a, b) => a.label.localeCompare(b.label)))
        .filter(c => allowedCategoryTypes.includes(c.value))
    });
  }

  handleChange = (key, value) => {
    const category: CategoryModel = { ...this.state.category };
    category[key] = value;
    this.setState({ category: { ...category } });
  };

  //TODO: Unite handle change into one method
  handleCheckboxChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const category: CategoryModel = { ...this.state.category };
    category[name] = value;
    this.setState({ category: { ...category } });
  }

  isValidAddEditForm() {
    let message = '';

    const { category } = this.state;

    if (!category.name || category.name.trim() === '') {
      message += Translate('Please enter name') + '<br />';
    }

    // if (!category.categoryTypeId) {
    //   message += Translate('Please select type') + '<br />';
    // }

    this.setState({
      validationMessage: message
    });

    return message === '';
  }

  handleSaveButton = (event) => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.props.saveClick(this.state.category);
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  public render() {

    const { category, isLoading, categoryTypes } = this.state;

    let header = '';

    if (!category.id) {
      header = Translate('NewCategory');
    } else {
      header = Translate('EditCategory');
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Dialog
          open={this.props.isVisible}
          onClose={this.handleCancelButton}
          fullWidth
        >
          <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{header}</Modal.DialogTitle>
          <Modal.DialogContent>
            {isLoading ? <Spinner /> : null}
            <Snackbar ref={(el) => this.snackbar = el} />
            <div>
              {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                <div style={{ width: "50%", marginRight: 10 }}>
                  <TextField
                    autoFocus
                    name="name"
                    label={Translate("Name")}
                    type="text"
                    onChange={(e) => this.handleChange('name', e.target['value'])}
                    value={category && category.name ? category.name : ""}
                  />
                </div>
                <div style={{ width: "50%", marginRight: 10 }}>
                  <FormControl>
                    <InputLabel htmlFor="categoryType-label">{Translate('Type')}</InputLabel>
                    <Select
                      value={category.categoryTypeId ? category.categoryTypeId : ''}
                      onChange={(e) => this.handleChange('categoryTypeId', e.target.value)}
                      inputProps={{
                        id: 'categoryType-label'
                      }}
                    >
                      {
                        categoryTypes.map(m =>
                          <MenuItem
                            key={m.value + 'categoryType'}
                            value={m.value}>
                            {m.value ? m.label : <em>{m.label}</em>}
                          </MenuItem>)
                      }
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                <div style={{ width: '50%', marginRight: 10 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isActive"
                        checked={category.isActive}
                        onChange={(e) => this.handleCheckboxChange(e)}
                        color="primary"
                      />
                    }
                    label={Translate("Active")}
                    style={{ marginLeft: -10 }}
                  />
                </div>
              </div>
            </div>
          </Modal.DialogContent>
          <Modal.DialogActions>
            <div>
              <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                {Translate("Cancel")}
              </Button>
              <Button onClick={(e) => this.handleSaveButton(e)} color="primary" variant="contained">
                {Translate("Save")}
              </Button>
            </div>
          </Modal.DialogActions>
        </Dialog >
      </MuiThemeProvider>
    )
  }
}

export default CategoryAddEditDialog;